module.exports = __webpack_public_path__ + "img/20180414165754.6fceaa80.jpg";